import React from 'react';
import './media/css/modal.css';  // Import custom CSS

const Modal = ({ show, onClose, children }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
